<template>
  <div class="default-layout">
    <div>
      <header>
        <div class="default-layout__menu-wrapper">
          <span class="default-layout__logo">
            <img
              draggable="false"
              class="logo"
              alt="logo"
              src="../../assets/imgs/logo/logo.webp"
            />
          </span>
          <ul class="default-layout__menu">
            <a href="#start">
              <li class="default-layout__menu-item">
                <i class="fa fa-home"></i>
                INÍCIO
              </li>
            </a>
            <a href="#gallery">
              <li class="default-layout__menu-item">
                <i class="fa-solid fa-images"></i>
                GALERIA
              </li>
            </a>
            <a class="open-oursite-button" href="https://bannercotacao.com">
              <li class="default-layout__menu-item">
                <i class="fa-solid fa-up-right-from-square"></i>
                NOSSO SITE
              </li>
            </a>
          </ul>
        </div>
      </header>
      <div class="default-layout__body">
        <div id="start" class="main-view">
          <div class="main-view__top--revert">
            <div class="main-view__top section-spacer content-card">
              <div>
                <span class="main-view__top-title"
                  >Transforme sua banca em uma marca profissional em
                  minutos</span
                >
                <span class="main-view__top-title--mobile"
                  >Transforme sua banca em uma marca profissional em
                  minutos</span
                >
                <p class="main-view__top-desc text-desc">
                  Crie banners e vídeos ilimitados, totalmente editáveis e
                  pensados especificamente para o mercado de bancas esportivas.
                  Sem precisar contratar designer ou gastar horas em ferramentas
                  complexas, você consegue gerar conteúdos visuais de alta
                  qualidade em poucos minutos. Aumente a credibilidade da sua
                  marca, conquiste mais clientes e destaque suas promoções com
                  imagens otimizadas para redes sociais, anúncios digitais e
                  campanhas de marketing.
                </p>
                <p class="main-view__top-desc--mobile text-desc">
                  Crie banners e vídeos ilimitados para bancas esportivas, sem
                  designer e em minutos. Atraia mais clientes e destaque suas
                  promoções com conteúdos prontos para redes e marketing
                  digital.
                </p>
                <highlight-button
                  @click="openWhatsapp"
                  class="open-whatsapp-button mt-2"
                >
                  <i class="fa-solid fa-arrow-up"></i>
                  Impussionar minha banca</highlight-button
                >
              </div>
              <img
                class="banner1-img"
                src="../../assets/imgs/others/banner1.webp"
                alt="Notebook de apresentação"
              />
            </div>
          </div>

          <div
            class="d-flex justify-content-around align-items-center section-spacer"
          >
            <img
              class="main-view__section-icons main-view__section-icons--return-investiment"
              src="../../assets/imgs/others/banner_invest_result.webp"
              alt="Celular com diversos apps"
            />
            <div class="main-view__benefits">
              <div class="content-card-wrap-5deg">
                <div
                  class="d-flex flex-column content-card content-card-wrap-5deg--revert"
                >
                  <h5 class="text-tile">
                    Seus investimentos são convertidos em novos clientes
                  </h5>

                  Cada banner ou vídeo que você gera com nosso sistema não é
                  apenas uma peça visual — é uma ferramenta de captação de
                  clientes. Com designs otimizados e direcionados para o público
                  certo, seus investimentos se transformam em mais visitas e
                  mais resultados para o seu site, sem depender de designers ou
                  agências. É publicidade que gera retorno real, direto na sua
                  banca.
                </div>
              </div>
            </div>
          </div>

          <div
            class="d-flex flex-row-reverse justify-content-around align-items-center section-spacer"
          >
            <img
              class="main-view__section-icons main-view__section-icons--all-ready"
              src="../../assets/imgs/others/download.webp"
              alt="Tudo pronto, basta baixar!"
            />
            <div class="main-view__benefits">
              <div class="content-card-wrap-5deg">
                <div
                  class="d-flex flex-column content-card content-card-wrap-5deg--revert"
                >
                  <h5 class="text-tile">Tudo pronto, basta baixar!</h5>

                  <p>
                    Na plataforma você escolhe os jogos que deseja destacar e
                    seleciona os modelos preferidos. Quer praticidade total? É
                    só baixar tudo já pronto, com os jogos aplicados
                    automaticamente. Em poucos cliques, sua banca ganha artes
                    profissionais prontas para publicar e atrair mais clientes.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            class="d-flex justify-content-around align-items-center section-spacer"
          >
            <img
              class="main-view__section-icons main-view__section-icons--customize"
              src="../../assets/imgs/others/customize.webp"
              alt="Como funciona"
            />
            <div class="main-view__benefits">
              <div class="content-card-wrap-5deg">
                <div
                  class="d-flex flex-column content-card content-card-wrap-5deg--revert"
                >
                  <h5 class="text-tile">
                    Personalize do seu jeito, em segundos
                  </h5>

                  <p>
                    Nossa plataforma conta com um editor intuitivo de arrasta e
                    solta, onde você pode mover elementos livremente e ajustar
                    cada detalhe conforme sua preferência. Altere imagens,
                    troque cores, adicione efeitos e deixe seus banners únicos.
                    E não para por aí: o mesmo nível de personalização também
                    está disponível nos vídeos, permitindo criar conteúdos
                    profissionais totalmente adaptados à sua banca.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            class="d-flex flex-row-reverse justify-content-around align-items-center section-spacer"
          >
            <img
              class="main-view__section-icons main-view__section-icons--economy"
              src="../../assets/imgs/others/economic.webp"
              alt="Como funciona"
            />
            <div class="main-view__benefits">
              <div class="content-card-wrap-5deg">
                <div
                  class="d-flex flex-column content-card content-card-wrap-5deg--revert"
                >
                  <h5 class="text-tile">Poderoso, mas econômico!</h5>

                  <p>
                    Um designer cobra em média R$30 a R$40 por banner. Com nosso
                    sistema, você paga R$ 250 mensal, o equivalente a R$8 por
                    dia no plano mais popular e pode baixar quantos banners
                    quiser, escolhendo entre um acervo com mais de 3.000 modelos
                    prontos. Economize tempo e dinheiro sem abrir mão da
                    qualidade.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!--About-->
          <div class="main-view__about section-spacer">
            <div class="main-view__product-video-card">
              <video
                class="main-view__banner-editor-video"
                controls
                autoplay
                loop
                muted
                playsinline
                preload="auto"
              >
                <source
                  src="../../assets/videos/banner_editor_video.mp4"
                  type="video/mp4"
                />
                <source
                  src="../../assets/videos/banner_editor_video.webm"
                  type="video/webm"
                />
              </video>
              <small class="p-2">Exemplo do processo de edição.</small>
            </div>
          </div>

          <!--Gallery-->
          <div
            id="gallery"
            class="section-spacer d-flex flex-column align-items-center"
          >
            <div class="w-100">
              <span class="main-view__solutions-title"
                >GALERIA COM ALGUNS BANNERS</span
              >
              <MasonryWall
                class="mt-3"
                :items="galleryImgs"
                :gap="16"
                :column-width="220"
                :min-columns="2"
                :max-columns="3"
              >
                <template #default="{ item }">
                  <img
                    @click="showMedia(item.src)"
                    :src="item.src"
                    class="main-view__gallery-card"
                  />
                </template>
              </MasonryWall>
            </div>

            <highlight-button
              @click="openWhatsapp"
              class="open-whatsapp-button mt-3"
            >
              <i class="fa-solid fa-arrow-up"></i>
              Impussionar minha banca</highlight-button
            >
          </div>
        </div>
      </div>
    </div>
    <footer>
      <div class="default-layout__footer">
        <p>
          © Copyright {{ currentYear }} Bannercotação - Todos os direitos
          reservados. A bannercotação é uma plataforma de marketing para bancas
          esportivas.
          <br />
        </p>
      </div>
    </footer>

    <div
      title="Clique para ir ao topo da página"
      @click="moveToTop"
      class="move-to-top-bt"
    >
      <i class="fa-solid fa-arrow-up"></i>
    </div>

    <media-card :visible="mediaShow" @close="mediaShow = false">
      <img class="h-100" :src="mediaSrc" />
    </media-card>
  </div>
</template>

<script>
import HighlightButton from "@/components/buttons/HighlightButton.vue";
import img01 from "../../assets/imgs/gallery/01.webp";
import img02 from "../../assets/imgs/gallery/02.webp";
import img03 from "../../assets/imgs/gallery/03.webp";
import img04 from "../../assets/imgs/gallery/04.webp";
import img05 from "../../assets/imgs/gallery/05.webp";
import img06 from "../../assets/imgs/gallery/06.webp";
import img07 from "../../assets/imgs/gallery/07.webp";
import img08 from "../../assets/imgs/gallery/08.webp";
import img09 from "../../assets/imgs/gallery/09.webp";
import MediaCard from "@/components/cards/MediaCard.vue";
import { ref } from "vue";
import MasonryWall from "@yeger/vue-masonry-wall";

export default {
  components: { HighlightButton, MediaCard, MasonryWall },

  setup() {
    document.title = "Bannercotação";
    const galleryImgs = [
      { src: img01 },
      { src: img02 },
      { src: img03 },
      { src: img04 },
      { src: img05 },
      { src: img06 },
      { src: img07 },
      { src: img08 },
      { src: img09 },
    ];
    const mediaShow = ref(false);
    const mediaSrc = ref(null);

    const moveToTop = () => {
      document.querySelector(".app-wrapper").scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    const openWhatsapp = () => {
      window.open("https://api.whatsapp.com/send?phone=558788211276");
    };

    const showMedia = (src) => {
      mediaShow.value = true;
      mediaSrc.value = src;
    };

    return {
      moveToTop,
      galleryImgs,
      openWhatsapp,
      mediaSrc,
      showMedia,
      mediaShow,
    };
  },
};
</script>

<style lang="scss">
@use "~/_colors" as *;
@use "~/_colors.scss" as *;

@media screen and (max-width: 1779px) {
  .default-layout {
    width: 70% !important;
  }
}
@media screen and (max-width: 1550px) {
  .default-layout {
    width: 75% !important;
  }
}
@media screen and (max-width: 1300px) {
  .default-layout {
    width: 90% !important;
  }
}
@media screen and (max-width: 1113px) {
  .main-view__top {
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;

    & .main-view__top-desc--mobile,
    & .main-view__top-title--mobile {
      display: block !important;
    }

    & .main-view__top-desc,
    & .main-view__top-title {
      display: none;
    }

    .banner1-img {
      margin-left: 0 !important;
    }
  }

  .default-layout__menu {
    padding: 0 !important;
  }
}
@media screen and (max-width: 696px) {
  .default-layout .banner1-img {
    width: 300px;
  }
  .default-layout .main-view__section-icons {
    display: none;
  }
  .default-layout .main-view__benefits {
    width: 90%;
  }
  .default-layout .main-view__contact-icon {
    width: 70px;
  }
  .default-layout .default-layout__menu-wrapper {
    flex-direction: column;
    align-items: center;
  }
  .default-layout .logo {
    margin-bottom: 1rem;
  }
  .default-layout .content-card-wrap-5deg {
    transform: rotate(1.5deg);
  }
  .default-layout .content-card-wrap-5deg--revert {
    transform: rotate(-1.5deg);
  }
}
@media screen and (max-width: 908px) {
  .main-view__data-card {
    width: 500px !important;
  }
}
@media screen and (max-width: 843px) {
  .default-layout .main-view__gallery {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}

@keyframes notebook-float-anim {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-20px);
  }

  100% {
    transform: translateY(0);
  }
}

@keyframes shake-float-anim {
  0% {
    transform: translate(0, -5px);
  }

  50% {
    transform: translate(-10px, -10px) rotate(-2deg);
  }

  100% {
    transform: translate(0, 0) rotate(0);
  }
}
@keyframes shake-side-float-anim {
  0% {
    transform: translate(0px, 0px) rotate(0deg);
  }
  10% {
    transform: translate(-3px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(3px, 2px) rotate(1.5deg);
  }
  30% {
    transform: translate(-4px, -1px) rotate(-1.5deg);
  }
  40% {
    transform: translate(4px, 2px) rotate(1deg);
  }
  50% {
    transform: translate(-2px, -2px) rotate(-0.5deg);
  }
  60% {
    transform: translate(2px, 1px) rotate(0.5deg);
  }
  70% {
    transform: translate(-1px, 3px) rotate(-1deg);
  }
  80% {
    transform: translate(1px, -1px) rotate(0.5deg);
  }
  90% {
    transform: translate(-1px, 1px) rotate(-0.5deg);
  }
  100% {
    transform: translate(0px, 0px) rotate(0deg);
  }
}

.default-layout {
  width: 60%;
  height: 100%;
  color: white;
  margin: auto;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 10px 0 10px;

  header {
    padding-top: 3rem;
  }
}
.default-layout__logo {
  color: white;
}
.default-layout__menu-wrapper {
  display: flex;
  justify-content: space-between;
  color: white;
}
.default-layout__menu {
  list-style: none;
  display: flex;

  a {
    color: unset;
  }
}
.default-layout__menu-item {
  transition: 0.3s linear;
  float: left;
  margin-right: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;

  & i {
    margin-right: 5px;
    margin-left: 5px;
    margin-top: -4px;
  }

  &:hover {
    color: $secondary-color;
  }
}
.default-layout__footer {
  padding: 1rem 0 1rem 0;
}
.default-layout__body {
  margin-top: 3rem;
}

.logo {
  width: 40px;
}

.content-card {
  border: solid 1px darken($primary-color, 5%);
  padding: 2rem;
  border-radius: 10px;
  background: lighten($primary-color, 5%);
}
.main-view__top-title {
  font-size: 2rem;
}
.main-view__top-title--mobile {
  font-size: 1.1rem;
  font-weight: bold;
}
.main-view__top-title--mobile {
  display: none;
}
.banner1-img {
  width: 350px;
  margin-left: 2rem;
  animation-name: notebook-float-anim;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  box-shadow: 0 0 10px 3px $highlight-color;
  border-radius: 10px;
}
.main-view__top {
  display: flex;
  justify-content: space-between;
  transform: rotate(1deg);

  .main-view__top-desc--mobile {
    display: none;
  }
}
.main-view__top--revert {
  background: $secondary-color;
  transform: rotate(-1deg);
  border-radius: 10px;
}
.main-view__data-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: unset !important;
  text-align: center;
}
.data-card-icon {
  width: 100px;
  margin-bottom: 3px;
}
.main-view__ours-products {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  column-gap: 2rem;
  row-gap: 2rem;
}
.main-view__section-icons {
  width: 250px;
}
.main-view__section-icons--return-investiment {
  animation-name: shake-float-anim;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
.main-view__section-icons--all-ready {
  animation-name: shake-side-float-anim;
  animation-duration: 12s;
  animation-iteration-count: infinite;
  animation-direction: alternate-reverse;
}
.main-view__section-icons--customize {
  animation-name: shake-side-float-anim;
  animation-duration: 10s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
.main-view__section-icons--economy {
  animation-name: shake-side-float-anim;
  animation-duration: 8s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
.main-view__contact-icon {
  width: 150px;
  margin-right: 2rem;
}
.main-view__banner-editor-video {
  width: 100%;
}
.main-view__product-video-card {
  border-radius: 12px;
  transform: skewX(10deg);
  width: 100%;
}
.section-spacer {
  margin-bottom: 5rem;
}
.main-view__about {
  display: flex;
  justify-content: center;
  background: lighten($primary-color, 10%);
  border-radius: 10px;
  transform: skewX(-7deg);
}
.main-view__product-video-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3px;
}
.content-card-wrap {
  background: $secondary-color;
  border-radius: 10px;
}
.content-card-wrap-5deg {
  @extend .content-card-wrap;
  transform: rotate(5deg);
}
.content-card-wrap-5deg--revert {
  transform: rotate(-5deg);
}
.content-card-wrap-2deg {
  @extend .content-card-wrap;
  transform: rotate(2deg);
}
.content-card-wrap-2deg--revert {
  transform: rotate(-2deg);
}
.move-to-top-bt {
  background: white;
  padding: 1.5rem;
  position: fixed;
  bottom: 50px;
  right: 50px;
  border-radius: 2rem;
  color: black;
  box-shadow: 0 0 4px 4px black;
  cursor: pointer;
}
.main-view__gallery-card {
  transition: 0.3s linear;
  margin-bottom: 16px;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  border: solid 2px $secondary-color;

  img {
    width: 100%;
    border: solid 2px $secondary-color;
  }

  &:hover {
    transform: scale(1.05, 1.05);
  }
}
.main-view__benefits {
  width: 50%;
}
</style>
